import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Mail, User } from 'lucide-react'
import type { PressKitConfig } from '@/types'
import type { ResolvedStat } from '../hooks/usePressKit'

interface PressKitBioSectionProps {
  config: PressKitConfig
  stats: ResolvedStat[]
}

export function PressKitBioSection({ config, stats }: PressKitBioSectionProps) {
  return (
    <section className="space-y-8">
      {config.bioContent && (
        <div className="prose prose-sm dark:prose-invert max-w-none text-muted-foreground [&_a]:text-foreground [&_a]:underline [&_strong]:text-foreground">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{config.bioContent}</ReactMarkdown>
        </div>
      )}

      {stats.length > 0 && (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="rounded-lg border bg-card px-4 py-5 text-center"
            >
              <p className="text-3xl font-bold tracking-tight">{stat.value}</p>
              <p className="mt-1 text-sm text-muted-foreground">{stat.label}</p>
            </div>
          ))}
        </div>
      )}

      {(config.contactName || config.contactEmail) && (
        <div className="rounded-lg border bg-muted/30 p-5">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-3">
            Media Contact
          </h3>
          <div className="space-y-1.5">
            {config.contactName && (
              <div className="flex items-center gap-2 text-sm">
                <User className="h-4 w-4 text-muted-foreground shrink-0" />
                <span>{config.contactName}</span>
              </div>
            )}
            {config.contactEmail && (
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4 text-muted-foreground shrink-0" />
                <a
                  href={`mailto:${config.contactEmail}`}
                  className="hover:underline text-foreground"
                >
                  {config.contactEmail}
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  )
}
